import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { Link } from 'react-router-dom'; // REINSERITO LINK
import { 
  Handshake, Tag, Plus, MapPin, Trash2, Loader2, X, // REINSERITO TAG
  ExternalLink, Utensils, Scissors, Dumbbell, ShoppingBag, 
  CheckCircle, Upload, AlertCircle, Percent 
} from 'lucide-react';
import PageHeader from '../components/PageHeader';
import SEO from '../components/SEO';
import LoadingScreen from '../components/LoadingScreen';

// COSTANTI
const MAX_FILE_SIZE_MB = 5;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const MAX_NAME_LENGTH = 50;
const MAX_DESC_LENGTH = 500;
const MAX_DISCOUNT_LENGTH = 20; 
const ADMIN_EMAIL = 'info@tusciahub.it'; 

const Partners = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false); 
  
  // Filtri
  const [selectedCategory, setSelectedCategory] = useState('Tutti');
  const categories = ['Tutti', 'Food & Drink', 'Servizi', 'Sport', 'Shopping'];

  // Stati Modali
  const [isSellOpen, setIsSellOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fileError, setFileError] = useState(false);
  const [toast, setToast] = useState(null);

  const [newItem, setNewItem] = useState({
    name: '', description: '', discount: '', category: 'Food & Drink', 
    address: '', website: '', image: null, termsAccepted: false
  });

  useEffect(() => {
    const init = async () => {
        setLoading(true);
        await checkUser();
        await fetchItems();
        setLoading(false);
    };
    init();
  }, []);

  // --- FIX SCROLL DEFINITIVO ---
  useEffect(() => {
    if (isSellOpen || selectedItem) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
    return () => { 
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [isSellOpen, selectedItem]);

  const checkUser = async () => { 
      const { data: { user } } = await supabase.auth.getUser(); 
      setUser(user); 
      if (user && user.email === ADMIN_EMAIL) setIsAdmin(true);
  };

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  const formatUrl = (url) => {
      if (!url) return '#';
      return url.startsWith('http') ? url : `https://${url}`;
  };

  const fetchItems = async () => {
    try {
      const { data, error } = await supabase.from('partners').select('*').order('created_at', { ascending: false });
      if (error) throw error;
      setItems(data || []);
    } catch (error) { console.error(error); }
  };

  const handleFileChange = (e) => {
      const file = e.target.files[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) { showToast("Solo immagini.", "error"); return; }
      if (file.size > MAX_FILE_SIZE_BYTES) { setFileError(true); setNewItem({ ...newItem, image: null }); } 
      else { setFileError(false); setNewItem({ ...newItem, image: file }); }
  };

  const handleAddItem = async (e) => {
    e.preventDefault(); 
    if (!user) return showToast("Devi accedere.", "error");
    if (!newItem.termsAccepted) return showToast("Accetta i termini.", "error");
    if (fileError) return showToast("File troppo grande.", "error");
    
    setIsSubmitting(true);
    try {
      let publicUrl = null;
      if (newItem.image) {
          const fileExt = newItem.image.name.split('.').pop();
          const fileName = `${user.id}/${Date.now()}_partner.${fileExt}`;
          const { error: uploadError } = await supabase.storage.from('partners_images').upload(fileName, newItem.image);
          if (uploadError) throw uploadError;
          const res = supabase.storage.from('partners_images').getPublicUrl(fileName);
          publicUrl = res.data.publicUrl;
      }
      const { error: dbError } = await supabase.from('partners').insert([{ 
        name: newItem.name, description: newItem.description, discount: newItem.discount, 
        category: newItem.category, address: newItem.address, website: newItem.website, 
        image_url: publicUrl, user_id: user.id 
      }]);
      if (dbError) throw dbError;
      showToast("Partner segnalato!", "success");
      setIsSellOpen(false); 
      setNewItem({ name: '', description: '', discount: '', category: 'Food & Drink', address: '', website: '', image: null, termsAccepted: false });
      fetchItems();
    } catch (error) { showToast("Errore: " + error.message, "error"); } 
    finally { setIsSubmitting(false); }
  };

  const handleDelete = async (itemId, imageUrl) => { 
      if(!window.confirm("Eliminare?")) return; 
      try { 
          if (imageUrl) {
              const filePath = imageUrl.split('/partners_images/')[1];
              await supabase.storage.from('partners_images').remove([filePath]);
          }
          await supabase.from('partners').delete().eq('id', itemId);
          setItems(items.filter(i => i.id !== itemId)); 
          showToast("Eliminato.", "success");
          if(selectedItem?.id === itemId) setSelectedItem(null); 
      } catch(err) { showToast("Errore.", "error"); } 
  };

  const getCategoryIcon = (cat) => {
      switch(cat) {
          case 'Food & Drink': return <Utensils size={14}/>;
          case 'Servizi': return <Scissors size={14}/>;
          case 'Sport': return <Dumbbell size={14}/>;
          case 'Shopping': return <ShoppingBag size={14}/>;
          default: return <Tag size={14}/>;
      }
  };

  const filteredItems = items.filter(item => selectedCategory === 'Tutti' || item.category === selectedCategory);
  const inputStyle = "w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3.5 text-sm font-medium text-slate-700 placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-rose-200 focus:border-rose-300 outline-none transition-all shadow-sm";

  if (loading) return <LoadingScreen />;

  return (
    <div className="relative min-h-screen bg-slate-100 pt-24 pb-20 px-6 font-sans text-slate-800">
      <SEO title="Sconti Studenti" description="Convenzioni Unitus." url="/partner" />
      <div className="absolute top-0 left-[-10%] w-[500px] h-[500px] bg-rose-200/40 rounded-full blur-[100px] mix-blend-multiply pointer-events-none"></div>
      
      {toast && (
        <div className={`fixed bottom-10 left-1/2 -translate-x-1/2 z-[10000] animate-in slide-in-from-bottom-5 fade-in duration-300 px-6 py-4 rounded-xl shadow-2xl flex items-center gap-4 border min-w-[320px] ${toast.type === 'error' ? 'bg-red-900 text-white border-red-800' : 'bg-slate-900 text-white border-slate-800'}`}>
            {toast.type === 'error' ? <AlertCircle className="text-red-400"/> : <CheckCircle className="text-green-400"/>}
            <span className="font-bold text-sm">{toast.message}</span>
        </div>
      )}

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar { height: 6px; width: 6px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
      `}</style>

      <div className="relative z-10 max-w-7xl mx-auto">
        <PageHeader title="Partner & Sconti" subtitle="Risparmia in città con la tua tessera studente." breadcrumbs={[{label: 'Sconti'}]} />

        {/* FILTRI */}
        <div className="bg-white p-6 rounded-[2rem] border border-slate-200 shadow-sm mb-10">
            <div className="flex flex-wrap xl:flex-nowrap gap-6 items-center justify-between">
                <div className="flex-1 w-full md:w-auto overflow-x-auto pb-4 custom-scrollbar">
                    <div className="flex gap-2">
                        {categories.map(c => (
                            <button key={c} onClick={() => setSelectedCategory(c)} className={`px-5 py-2.5 rounded-xl text-sm font-bold whitespace-nowrap transition border ${selectedCategory === c ? 'bg-rose-600 text-white border-rose-600 shadow-md' : 'bg-white border-slate-200 text-slate-500 hover:border-rose-200 hover:text-rose-600'}`}>{c}</button>
                        ))}
                    </div>
                </div>
                <button onClick={() => user ? setIsSellOpen(true) : showToast("Accedi per segnalare!", "error")} className="w-full xl:w-auto bg-rose-600 hover:bg-rose-700 text-white px-8 py-3.5 rounded-xl font-bold shadow-lg shadow-rose-200 flex items-center justify-center gap-2 transition-transform hover:-translate-y-0.5 active:scale-95 shrink-0 mt-2 xl:mt-0">
                    <Plus size={20}/> Segnala Partner
                </button>
            </div>
        </div>

        {/* LISTA PARTNER */}
        {filteredItems.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredItems.map(item => (
                    <div key={item.id} onClick={() => setSelectedItem(item)} className="group bg-gradient-to-b from-white to-rose-50 rounded-[2.5rem] border-2 border-rose-100 shadow-xl hover:shadow-2xl hover:border-rose-300 hover:-translate-y-2 transition-all duration-300 cursor-pointer overflow-hidden flex flex-col h-full relative">
                        <div className="h-28 bg-white/50 border-b border-rose-100 relative backdrop-blur-sm">
                            <span className="absolute top-5 right-5 bg-white border border-rose-100 text-rose-600 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wide flex items-center gap-1 shadow-sm">
                                {getCategoryIcon(item.category)} {item.category}
                            </span>
                        </div>
                        <div className="absolute top-10 left-6 w-24 h-24 bg-white rounded-3xl border-2 border-rose-100 p-2 shadow-lg flex items-center justify-center group-hover:scale-105 transition-transform duration-300">
                            {item.image_url ? <img src={item.image_url} className="w-full h-full object-contain rounded-2xl" /> : <Handshake size={32} className="text-rose-300"/>}
                        </div>
                        <div className="pt-10 p-6 flex flex-col flex-grow">
                            <h3 className="font-black text-slate-900 text-2xl leading-tight mb-4 mt-2 line-clamp-2 group-hover:text-rose-600 transition-colors">{item.name}</h3>
                            <div className="mb-5">
                                <div className="w-full bg-gradient-to-r from-orange-500 to-rose-600 p-4 rounded-2xl text-white shadow-lg shadow-orange-200/50 flex flex-col items-center justify-center relative overflow-hidden group-hover:scale-[1.02] transition-transform duration-300">
                                    <p className="text-[10px] font-bold opacity-90 uppercase tracking-widest mb-1 text-white/90">Sconto</p>
                                    <span className="text-4xl font-black tracking-tighter text-white">{item.discount}</span>
                                </div>
                            </div>
                            <p className="text-slate-600 text-sm line-clamp-2 mb-4 leading-relaxed font-medium">{item.description}</p>
                            <div className="mt-auto pt-4 border-t border-rose-100 flex items-center justify-between">
                                <span className="text-xs font-bold text-rose-600 group-hover:text-rose-700 transition flex items-center gap-1">Vedi dettagli <ExternalLink size={12}/></span>
                                {user && (user.id === item.user_id || isAdmin) && (
                                    <button onClick={(e) => { e.stopPropagation(); handleDelete(item.id, item.image_url); }} className="bg-white text-red-500 p-2.5 rounded-xl hover:bg-red-50 transition z-20 border border-red-100 shadow-sm"><Trash2 size={18}/></button>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        ) : (
            <div className="text-center py-24 bg-white border-2 border-dashed border-slate-200 rounded-[3rem]">
                <h3 className="font-bold text-slate-900 text-lg">Nessun partner qui</h3>
            </div>
        )}

        {/* --- MODALE DETTAGLIO --- */}
        {selectedItem && (
            <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
                <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setSelectedItem(null)}></div>
                <div className="relative z-10 bg-white w-full max-h-[90vh] md:max-w-2xl rounded-[2.5rem] flex flex-col shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300">
                    <div className="p-6 border-b border-slate-100 flex items-start justify-between bg-slate-50/50 shrink-0">
                        <div className="flex items-center gap-4 pr-2">
                            <div className="w-16 h-16 rounded-2xl bg-white border border-slate-100 flex items-center justify-center overflow-hidden shrink-0 shadow-sm">
                                {selectedItem.image_url ? <img src={selectedItem.image_url} className="w-full h-full object-contain p-2" /> : <Handshake size={28} className="text-rose-300"/>}
                            </div>
                            <div>
                                <span className="bg-rose-100 text-rose-700 px-2 py-0.5 rounded-lg text-[10px] font-bold uppercase tracking-wide mb-1 inline-block">{selectedItem.category}</span>
                                <h2 className="text-xl md:text-2xl font-black text-slate-900 leading-tight line-clamp-2">{selectedItem.name}</h2>
                            </div>
                        </div>
                        <button onClick={() => setSelectedItem(null)} className="p-2 bg-white rounded-full hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition shadow-sm border border-slate-100 shrink-0"><X size={20}/></button>
                    </div>
                    <div className="p-6 overflow-y-auto custom-scrollbar flex-1">
                        <div className="bg-gradient-to-br from-orange-500 to-rose-600 p-8 rounded-3xl text-white mb-8 shadow-xl shadow-rose-200 relative overflow-hidden text-center">
                            <p className="text-xs font-bold opacity-90 uppercase tracking-widest mb-2 relative z-10">Sconto Studenti Esclusivo</p>
                            <p className="text-5xl font-black relative z-10">{selectedItem.discount}</p>
                            <p className="text-xs mt-3 opacity-90 relative z-10 max-w-sm mx-auto">Mostra la tua tessera studente o il libretto universitario alla cassa.</p>
                        </div>
                        <div className="prose prose-slate prose-sm text-slate-600 mb-8 leading-relaxed">
                            <h3 className="font-bold text-slate-900 text-lg mb-2">Dettagli</h3>
                            <p className="whitespace-pre-wrap">{selectedItem.description}</p>
                        </div>
                        <div className="flex flex-col gap-3">
                            {selectedItem.website && (
                                <a href={formatUrl(selectedItem.website)} target="_blank" rel="noopener noreferrer" className="w-full bg-slate-900 text-white py-4 rounded-2xl text-base font-bold flex items-center justify-center gap-2 transition shadow-lg hover:bg-rose-600 hover:shadow-rose-200 active:scale-95">
                                    <ExternalLink size={20}/> Visita Sito Web
                                </a>
                            )}
                            {selectedItem.address && (
                                <a href={`http://googleusercontent.com/maps.google.com/8{encodeURIComponent(selectedItem.name + ' ' + selectedItem.address)}`} target="_blank" rel="noopener noreferrer" className="w-full bg-white text-slate-700 border border-slate-200 py-4 rounded-2xl text-base font-bold flex items-center justify-center gap-2 transition hover:bg-slate-50 hover:border-slate-300 active:scale-95">
                                    <MapPin size={20} className="text-rose-500"/> Apri Mappa
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )}

        {/* --- MODALE UPLOAD --- */}
        {isSellOpen && (
            <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
                <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setIsSellOpen(false)}></div>
                <div className="relative z-10 bg-white w-full max-h-[90vh] md:max-w-lg rounded-[2.5rem] shadow-2xl flex flex-col animate-in zoom-in-95 duration-200 border border-white/20">
                    <div className="p-6 border-b border-slate-100 flex items-center justify-between shrink-0">
                        <h3 className="text-xl font-black text-slate-900">Segnala Partner</h3>
                        <button onClick={() => setIsSellOpen(false)} className="p-2 bg-slate-50 rounded-full hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition"><X size={20}/></button>
                    </div>
                    <div className="p-6 overflow-y-auto custom-scrollbar">
                        <p className="text-slate-500 text-sm mb-6 font-medium">Conosci un posto che fa sconti studenti?</p>
                        <form onSubmit={handleAddItem} className="space-y-4">
                            <div className="space-y-1"><input type="text" required maxLength={MAX_NAME_LENGTH} className={inputStyle} placeholder="Nome Attività" value={newItem.name} onChange={e => setNewItem({...newItem, name: e.target.value})} /></div>
                            <div className="grid grid-cols-2 gap-4">
                                <div className="flex bg-slate-50 border border-slate-200 rounded-xl overflow-hidden">
                                    <select className="w-full bg-transparent px-3 text-sm font-bold outline-none text-slate-600" value={newItem.category} onChange={e => setNewItem({...newItem, category: e.target.value})}>
                                        {categories.filter(c=>c!=='Tutti').map(c => <option key={c} value={c}>{c}</option>)}
                                    </select>
                                </div>
                                <input type="text" required maxLength={MAX_DISCOUNT_LENGTH} className={`${inputStyle} text-rose-600 font-bold`} placeholder="Sconto (es. 20%)" value={newItem.discount} onChange={e => setNewItem({...newItem, discount: e.target.value})} />
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <input type="text" required className={inputStyle} placeholder="Indirizzo" value={newItem.address} onChange={e => setNewItem({...newItem, address: e.target.value})} />
                                <input type="text" className={inputStyle} placeholder="Link Sito/Social" value={newItem.website} onChange={e => setNewItem({...newItem, website: e.target.value})} />
                            </div>
                            <textarea className={`${inputStyle} h-24 resize-none`} placeholder="Note..." maxLength={MAX_DESC_LENGTH} value={newItem.description} onChange={e => setNewItem({...newItem, description: e.target.value})}></textarea>
                            <div className="relative group">
                                <input type="file" accept="image/*" className="hidden" id="img-upload-partner" onChange={handleFileChange} />
                                <label htmlFor="img-upload-partner" className={`flex flex-col items-center justify-center h-24 w-full border-2 border-dashed rounded-2xl transition-all cursor-pointer ${fileError ? 'border-red-300 bg-red-50' : 'border-slate-200 bg-slate-50 hover:bg-slate-100'}`}>
                                    {newItem.image ? <div className="flex flex-col items-center text-rose-600"><CheckCircle size={24}/><span className="text-xs font-bold">{newItem.image.name}</span></div> : <div className="flex flex-col items-center text-slate-400"><Upload size={18}/><span className="text-xs font-bold">{fileError ? "File troppo grande" : "Logo (Opzionale)"}</span></div>}
                                </label>
                            </div>
                            <label className="flex items-center gap-3 p-2 hover:bg-slate-50 rounded-lg"><input type="checkbox" required className="w-4 h-4 text-rose-600 rounded" checked={newItem.termsAccepted} onChange={e => setNewItem({...newItem, termsAccepted: e.target.checked})}/><span className="text-xs text-slate-500 font-medium">Accetto i <Link to="/terms" className="text-rose-600 font-bold hover:underline" target="_blank">Termini</Link>.</span></label>
                            <button disabled={isSubmitting} type="submit" className="w-full bg-slate-900 text-white py-4 rounded-xl font-bold text-lg hover:bg-rose-600 transition shadow-xl active:scale-95 flex items-center justify-center gap-2">{isSubmitting ? <Loader2 className="animate-spin"/> : 'Segnala Partner'}</button>
                        </form>
                    </div>
                </div>
            </div>
        )}
      </div>
    </div>
  );
};

export default Partners;